import { render, staticRenderFns } from "./IconCompetencyLibrary.vue?vue&type=template&id=7be4acd3"
import script from "./IconCompetencyLibrary.vue?vue&type=script&lang=js"
export * from "./IconCompetencyLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports